module.exports = __webpack_public_path__ + "img/vp_web_2.910ccc7c.png";